import { useTranslation } from "react-i18next";
import Image from "./Image";
import Details from "./Details";
import UpperDetails from "./UpperDetails";

const ConcertCard = ({ concert }) => {
  const { t } = useTranslation();
  const concertDate = new Date(concert.date);
  concertDate.setDate(concertDate.getDate() + 1);
  const isExpired = concertDate < new Date();
  const isMMISeason = concert.season === "mmi"; 

  return (
    <div className="col-md-4 space reducewidth" key={concert.id}>
      <div
        className={`service-style-01 concertcardfirst${
          isExpired ? " done" : ""
        }${isMMISeason ? " mmi-season" : ""}`}
      >
        <UpperDetails concert={concert} t={t} />
        <Image concert={concert} />
        <Details concert={concert} t={t} isExpired={isExpired} />
      </div>
    </div>
  );
};

export default ConcertCard;
